import { AuthTitleSC } from '../../../auth.styled';
import styled from 'styled-components';
import HeaderSC from '../../../components/header/header.styled';

export const StepCodeSC = styled.div`
  grid-area: form;

  .form {
    display: flex;
    flex-direction: column;
  }

  ${HeaderSC} {
    align-self: flex-start;
    display: flex;
    align-items: flex-end;
    svg {
      position: static;
    }
    h1 {
      margin-left: 11px;
    }
  }

  ${AuthTitleSC} {
    margin-bottom: 16px;
  }

  .insert-code-text {
    color: #333d6c;
    margin-bottom: 30px;
  }

  .insert-code-email {
    font-weight: bold;
  }

  .verification-code-input {
    position: relative;
    width: 100% !important;
    display: flex;
    justify-content: center;
    margin-bottom: 3px;
    div:first-child {
      display: grid;
      grid-template-rows: 50px;
      grid-auto-flow: column;
      grid-auto-columns: minmax(30px, 50px);
      grid-column-gap: 8px;
    }

    input {
      width: auto !important;
      height: auto !important;
      border-radius: 10px;
      border: none;
      background: #caccd8;
      opacity: 0.3;
      font-family: 'Mulish', sans-serif;
    }
  }

  .resend-email {
    text-align: center;
    margin-top: 30px;
  }

  .resend-email_txt {
    display: block;
    margin-bottom: 5px;
  }

  .resend-email_btn {
    font-weight: 700;
    color: #6ad5e5;
    cursor: pointer;
  }

  .resend-email-error {
    margin-top: 5px;
  }

  .input-wrapper {
    margin-bottom: 30px;
  }
`;

export const LoaderSC = styled.div`
  grid-area: content;
  display: flex;
  justify-content: center;
  align-items: center;
`;
